import MeContainer from '../../../Components/Dashboards/Me';

export default function Me() {
    return (
        <div className='page-body'>
            <MeContainer />
        </div>
    );
}
